import { Box, Container, Grid } from '@material-ui/core'
import React from 'react'
import { useAuth0 } from '../../contexts/Auth0Context'
import { Header, Text, Button } from "@paro.io/base-ui";

const RegistrationLayout = ({ children }) => {
  const { loginWithRedirect } = useAuth0()

  const HeaderContent = () => (
    <div className="flex" >
      <Text size="sm" className="text-gray-400">
        Already have an account?
        <Button color="primary-on-dark" className="ml-2" onClick={() => loginWithRedirect()} label="Login" />
      </Text>
    </div>
  );

  return (
    <Box>
      <div className="md:hidden">
        <Header reverseColor={true} size="sm" className="sm-padding-rm">
          <HeaderContent />
        </Header>
      </div>
      <div className="hidden md:block">
      <Header reverseColor={true} size="md">
        <HeaderContent />
      </Header>
      </div>
      <Container maxWidth="md">
        <Grid container style={{ paddingBottom: 50 }}>
          <Grid item>{children}</Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default RegistrationLayout
